import React, { useState } from 'react';
export default function CreatorInspectorSection({ title, children }) {
  const [open, setOpen] = useState(true);
  return <section className="creator-inspector-section"><button type="button" className="creator-inspector-section-toggle" aria-expanded={open} onClick={() => setOpen(value => !value)}>{title}<span aria-hidden="true">{open ? '-' : '+'}</span></button><div hidden={!open}>{children}</div></section>;
}
